import { AxiosError } from 'axios'

/**
 * Whether a request was turned away by a rate limit rather than by a real
 * failure.
 *
 * The API answers 429 for this, and the status is all we have to go on: it also
 * sets Retry-After and the X-RateLimit-* headers, but its CORS configuration
 * does not expose them, so the browser cannot read them from another origin.
 *
 * Worth telling apart, because the two need opposite words. A limit means the
 * request was fine and the answer is "try again shortly"; anything else means
 * something went wrong. Showing the second for the first is how somebody who
 * asked for a mail a fourth time got told their password could not be reset.
 */
export const isRateLimited = (error: unknown): boolean =>
  (error as AxiosError)?.response?.status === 429
